/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useAuthenticationContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { isImpersonating } from '@aarhus-university/au-lib-react-components/src/lib/portals';
import MenuComponent from './MenuComponent';
import UtilityComponent from './UtilityComponent';
import { useImpersonationContext } from '../../lib/context';
import { useTranslationsContext } from '../../lib/translation';

type Props = {
  hasAnswered?: boolean;
  showQuota2?: IQuota2Type;
};

const MenuWrapperComponent: FC<Props> = ({
  hasAnswered = false,
  showQuota2,
}) => {
  const lang = window.userContext.preferredLanguage || window.appLang;
  const authenticated = useAuthenticationContext();
  const translations = useTranslationsContext();
  const { isApplicant, isImpersonator, canViewedUserBeImpersonated } = useImpersonationContext();
  const canImpersonateButHaveNotActivatedItYet = isImpersonator && !isApplicant && !isImpersonating();
  const noAccess = !isApplicant && !isImpersonator;

  const navs: INavItem[] = [];

  if (authenticated && hasAnswered) {
    navs.push({
      href: `${lang === 'en' ? '/en' : ''}/applications`,
      text: translations.menu.applications,
      childHrefs: [],
    });

    navs.push({
      href: `${lang === 'en' ? '/en' : ''}/receipt`,
      text: translations.menu.receipt,
      childHrefs: [],
    });
  }

  if (authenticated && typeof showQuota2 !== 'undefined' && showQuota2.type !== 'none' && !hasAnswered) {
    navs.push({
      href: `${lang === 'en' ? '/en' : ''}/applications`,
      text: translations.menu.applications,
      childHrefs: [],
    });

    navs.push({
      href: `${lang === 'en' ? '/en' : ''}/quota2?facultyId=${showQuota2.type === 'nat' ? '2' : '1'}`,
      text: translations.menu.quota2,
      childHrefs: [],
    });
  }

  let navItems = navs;
  if (!authenticated) {
    navItems = [];
  }

  if (canImpersonateButHaveNotActivatedItYet) {
    navItems = [];
  }

  if (noAccess) {
    navItems = [];
  }

  if (isImpersonator && isImpersonating() && !canViewedUserBeImpersonated) {
    navItems = [];
  }

  return (
    <>
      {createPortal(
        <MenuComponent navItems={navItems} />,
        document.querySelector('header nav .nav__site')!,
      )}
      {createPortal(
        <UtilityComponent />,
        document.querySelector('header nav .nav__utilities')!,
      )}
    </>
  );
};

MenuWrapperComponent.displayName = 'MenuWrapperComponent';
export default MenuWrapperComponent;
